import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/services/http/http.service';
import { RelationRelationCreateModel } from '@app/modules/relation-relation/models/relation-relation-create.model';
import { RelationRelationTableItemModel } from '@app/modules/relation-relation/models/relation-relation-table.model';
import { TableDataModel } from '@app/shared/models';
import { KeyValueModel } from '@app/shared/models/common/key-value.model';
import { TableFilterModel } from '@app/shared/models/table/table-filter.model';
import { TablePaginationModel } from '@app/shared/models/table/table-pagination.model';
import { TableSortingModel } from '@app/shared/models/table/table-sorting.model';
import { parse } from '@app/shared/utilities/url-search-params-parser';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RelationRelationService {
    private readonly endpoints = {
        overview: 'Relation/GetRelationsOverview',
        create: 'Relation/CreateRelationRelation',
        delete: 'Relation/DeleteRelationRelation?id=:id',
        searchRelations: 'Activity/GetRelationKeyValue',
    };

    constructor(private readonly httpService: HttpService) {}

    getOverview(
        relationId: number,
        sorting: TableSortingModel,
        pagination: TablePaginationModel,
        filter?: TableFilterModel[],
    ): Observable<TableDataModel<RelationRelationTableItemModel>> {
        const activityIdParam = `relationId=${relationId}`;
        const sortingFilter = filter ? `&${parse(filter, 'Filters')}` : '';
        const paginationParams = parse(pagination, 'pagination');
        const sortingParams = parse(sorting, 'sorting');

        return this.httpService.get<TableDataModel<RelationRelationTableItemModel>>(
            this.endpoints.overview + `?${activityIdParam}${sortingFilter}&${paginationParams}&${sortingParams}`,
        );
    }
    
    getRelations(searchQuery: string | null, skipCount: number): Observable<KeyValueModel[]> {
        const skipCountParam = `skipCount=${skipCount}`;
        const searchQueryParam = searchQuery ? `&searchQuery=${searchQuery}` : '';

        return this.httpService.get<KeyValueModel[]>(
            this.endpoints.searchRelations + `?${skipCountParam}${searchQueryParam}`,
        );
    }
 
    create(request: RelationRelationCreateModel): Observable<RelationRelationCreateModel> {
        return this.httpService.post<RelationRelationCreateModel>(this.endpoints.create, request);
    }

    delete(id: number): Observable<void> {
        return this.httpService.delete<void>(this.endpoints.delete.replace(':id', id.toString()));
    }
}
